import {
  Box,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  styled,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CardContent from "@mui/material/CardContent";
import styles from "../devoteeService.module.scss";
import { useState } from "react";
import { object, string, ValidationError } from "yup";
import commonStyles from "../../../App.module.scss";
import constants from "../../../config/constants.json"
import {
  CustomSelect,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomTextFeild,
  CommonOutlinedButton,
  CommonButton,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
  getUserName,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import ToastError from "../../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import ToastSuccess from "../../common/toast/toastSuccess";
import { ClipLoader } from "react-spinners";
import LOCALE from '../../../config/en-us.json';
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import { isBoolean, isNil } from "lodash";


interface RefundProps {
  onBackClick?: () => void;
}

interface ErrorMessageTypes {
  signinName: string;
  referenceNumber: string;
  typeofrefund: string;
  refundamount: string;
  reasonforrefund: string;
  checkNumber: string;
  RefundMode: string;
}
const CustomRadioButton = styled(Radio)`
  & svg {
    color: #f05802;
    height: 24px;
    width: 24px;
  }
`;

const Refund = (props: RefundProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    signinName: getDevoteeId()?.userId || "",
    referenceNumber: "",
    refundamount: "",
    typeofrefund: "",
    reasonforrefund: "",
    checkNumber: "",
    RefundMode: "2"
  });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    signinName: "",
    referenceNumber: "",
    refundamount: "",
    typeofrefund: "",
    checkNumber: "",
    reasonforrefund: "",
    RefundMode: ""
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [refundButton, setRefundButton] = useState<boolean>(true);
  const [cancelDisable, setCancelDisable] = useState<boolean>(false);

  const validationSchema = object().shape({
    signinName: string().required("Sign name is required"),
    referenceNumber: string().required("Reference Number is required")
      .matches(/^[0-9]+$/, "Reference Number must be a number"),
    refundamount: string()
      .required("Refund Amount is required")
      .matches(/^\d*\.?\d*$/, "Refund Amount must be a number"),
    typeofrefund: string().required("Type of Refund required"),
    checkNumber: formData.RefundMode === "1" ? string() : string().required("Check Number is required")
      .matches(/^[0-9]+$/, "Reference Number must be a number"),
    reasonforrefund: string().required("Reason for refund"),
    // RefundMode: string().required("type of refund amount required")
  });


  const refundApiCall = () => {
    setCancelDisable(true);
    setLoading(true);
    const reqBody = {
      onBehalfOfUsername: getDevoteeId()?.userId?.toUpperCase(),
      receiptNumber: formData.referenceNumber,
      refundReason: formData.reasonforrefund,
      refundAmount: parseFloat(formData.refundamount),
      checkNumber: formData.checkNumber,
      refundType: formData.typeofrefund,
      RefundMode: formData.RefundMode
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.refundApi,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        const formattedAmount = formatAmount(res.data);
        const successMessage = LOCALE.REFUND_SUCCESS.replace('{{amount}}', formattedAmount);;
        // toast.custom(<ToastSuccess message={successMessage} />, {
        //     duration: 10000,
        //   });
        toast.custom(<SuccessPopup headerMessage="Items Deleted" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen}  />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          });
        setFormData({
          ...formData,
          signinName: getUserName() || "",
          referenceNumber: "",
          refundamount: "",
          typeofrefund: "",
          reasonforrefund: "",
          checkNumber: "",
        });
        setLoading(false);
        setRefundButton(true);
        setCancelDisable(false);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
        setLoading(false);
        setRefundButton(true);
        setCancelDisable(false);
      });
  };

  const handleCancel = () => {
    setFormData({
      ...formData,
      signinName: getUserName() || "",
      referenceNumber: "",
      refundamount: "",
      typeofrefund: "",
      reasonforrefund: "",
      checkNumber: "",
    });
  }

  const handleRefund = async () => {
    const errors: ErrorMessageTypes = {
      signinName: "",
      referenceNumber: "",
      refundamount: "",
      typeofrefund: "",
      checkNumber: "",
      reasonforrefund: "",
      RefundMode: ""
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);

      // Call your API or perform other actions here
      refundApiCall();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const handleFieldChange = (field: string, value: any) => {
    setRefundButton(false);
    setFormData({
      ...formData,
      [field]: value,
    });
  };
  const typeofrefundList = [
    {
      label: "Donation",
      id: "D",
    },
    {
      label: "Pooja",
      id: "P",
    },
  ];

  const typeofRefundType = [
    // {
    //   label: "Cash",
    //   id: "1",
    // },
    {
      label: "Check",
      id: "2",
    },
  ]
  const TypeOfRefund = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Select Pooja Location"
          value={formData.typeofrefund}
          id="typeOfRefund"
          onChange={(e) => {
            handleFieldChange("typeofrefund", e.target.value);
            setErrorMessage({ ...errorMessage, typeofrefund: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.typeofrefund ? styles.errorTextField : styles.textField
          }
        >
          {typeofrefundList.map((item, index: number) => (
            <CustomMenuItem key={index} value={item.id}>
              {item.label}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.typeofrefund ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.typeofrefund}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };
  const RefundType = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Select Pooja Location"
          value={formData.RefundMode} 
          id="typeOfRefund"
          onChange={(e) => {
            handleFieldChange("RefundMode", e.target.value);
            setErrorMessage({ ...errorMessage, RefundMode: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.typeofrefund ? styles.errorTextField : styles.textField
          }
        >
          {typeofRefundType.map((item, index: number) => (
            <CustomMenuItem key={index} value={item.id}>
              {item.label}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.RefundMode ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.RefundMode}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  //   const TypeOfRefundAmount = (): React.ReactElement => {
  //     return (
  //       <FormControl sx={{ width: "100%" }}>
  //         <CustomSelect
  //           IconComponent={KeyboardArrowDownIcon}
  //           placeholder="Select Pooja Location"
  //           value={formData.typeofrefund}
  //           defaultValue=""
  //           id="grouped-select"
  //           onChange={(e) => {
  //             handleFieldChange("typeofrefund", e.target.value);
  //             setErrorMessage({ ...errorMessage, typeofrefund: "" });
  //           }}
  //           className={
  //             errorMessage.typeofrefund ? styles.errorTextField : styles.textField
  //           }
  //         >
  //           {typeofrefundList.map((item, index: number) => (
  //             <CustomMenuItem key={index} value={item.label}>
  //               {item.label}
  //             </CustomMenuItem>
  //           ))}
  //         </CustomSelect>
  //         {errorMessage.typeofrefund ? (
  //           <Typography sx={{ color: "red", fontSize: "12px" }}>
  //             {errorMessage.typeofrefund}
  //           </Typography>
  //         ) : (
  //           ""
  //         )}
  //       </FormControl>
  //     );
  //   };

  const handleKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submission behavior
      handleRefund();
    }
  };

  const handleButtons = () => {
    return (
      <div>
        <CommonOutlinedButton className={commonStyles.cancelButton} onClick={handleCancel} disabled={cancelDisable} id="cancel">Reset</CommonOutlinedButton>
        <CommonButton className={commonStyles.saveButton} sx={{ marginLeft: "16px" }} onClick={handleRefund} disabled={refundButton} id="refund" >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Please wait...
              </span>
            </>
          ) : (
            "Refund"
          )}
        </CommonButton>
      </div>
    );
  };

  const radioButtons = (): React.ReactElement => {
    return (
      <RadioGroup sx={{ display: "flex", flexDirection: "row" }}>
        <FormControlLabel
          value="cash"
          control={
            <CustomRadioButton
              sx={{ "& .MuiSvgIcon-root": { fontSize: 10 } }}
            />
          }
          label="Cash"
        />
        <FormControlLabel
          value="check"
          control={
            <CustomRadioButton
              sx={{ "& .MuiSvgIcon-root": { fontSize: 10 } }}
            />
          }
          label="Check"
        />
      </RadioGroup>
    );
  };
  return (
    <>
      <Toaster />
      <div>
        <form className={styles.RefundContainer} onKeyDown={handleKeyPress}>
          <Typography component="div" className={styles.typoGraphyHeading}>
            Devotee Service
          </Typography>
          <div className={styles.formContainer}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "10px 0px"}}>
              <Typography component="div" className={styles.typoGraphy}>
                Refund
              </Typography>
              <div>
                {!isNil(props.onBackClick) && (
                  <CommonOutlinedButton
                    onClick={props.onBackClick}
                  >
                    Back to Search Devotee
                  </CommonOutlinedButton>
                )}
              </div>
            </div>
            <Card className={styles.cardContainer}>
              <div style={{ padding: "24px" }}>
                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                  <Grid xs={12} sm={3} item >
                    {CustomRequiredInputLabel("Name", true)}
                    <CustomTextFeild
                    id="sign-in-name"
                      fullWidth
                      // value={formData.signinName}
                      value={getDevoteeId()?.fullName?.toUpperCase()}
                      required
                      onChange={(e) => {
                        handleFieldChange("signinName", e.target.value);
                        setErrorMessage({ ...errorMessage, signinName: "" });
                      }}
                      className={
                        errorMessage.signinName
                          ? styles.errorTextField
                          : styles.textField
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    {errorMessage.signinName ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.signinName}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                  <Grid xs={12} sm={3} item >
                    {CustomRequiredInputLabel("Reference No.", true)}
                    <CustomTextFeild
                    id="referenceNumber"
                      fullWidth
                      required
                      value={formData.referenceNumber}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericRegex = /^[0-9]*$/; // Regex to allow only numeric characters

                        if (numericRegex.test(inputValue)) {
                          handleFieldChange("referenceNumber", inputValue);
                          setErrorMessage({
                            ...errorMessage,
                            referenceNumber: "",
                          });
                        } else {
                          // Display error message or handle invalid input
                          // For example:
                          setErrorMessage({
                            ...errorMessage,
                          });
                        }
                      }}

                      className={
                        errorMessage.referenceNumber
                          ? styles.errorTextField
                          : styles.textField
                      }
                      placeholder="Enter reference Number"
                    />
                    {errorMessage.referenceNumber ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.referenceNumber}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid xs={12} sm={3} item >
                    {CustomRequiredInputLabel("Refund Amount", true)}
                    <CustomTextFeild
                    id="refundAmount"
                      fullWidth
                      required
                      value={formData.refundamount}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericRegex = /^\d*\.?\d*$/; // Regex to allow only numeric characters

                        if (numericRegex.test(inputValue) && inputValue.length <= 10) {
                          handleFieldChange("refundamount", inputValue);
                          setErrorMessage({
                            ...errorMessage,
                            refundamount: "",
                          });
                        } else {
                          // Display error message or handle invalid input
                          // For example:
                          setErrorMessage({
                            ...errorMessage,
                          });
                        }
                      }}
                      className={
                        errorMessage.refundamount
                          ? styles.errorTextField
                          : styles.textField
                      }
                      placeholder="Enter Refund Amount"
                    />
                    {errorMessage.refundamount ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.refundamount}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>

                </Grid>
                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                  <Grid xs={12} sm={3} item >
                    {CustomRequiredInputLabel("Type of Refund", true)}
                    {TypeOfRefund()}
                  </Grid>
                  <Grid xs={12} sm={3} item >
                    {CustomRequiredInputLabel("Type of Refund Amount", true)}
                    {RefundType()}
                  </Grid>

                </Grid>

                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                {/* {formData.RefundMode === "2" && ( */}
                  <Grid xs={12} sm={3} item>
                    {CustomRequiredInputLabel("Check Number", true)}
                    <CustomTextFeild
                    id="checkNumber"
                      fullWidth
                      required
                      value={formData.checkNumber}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericRegex = /^[0-9]*$/; // Regex to allow only numeric characters

                        if (numericRegex.test(inputValue)) {
                          handleFieldChange("checkNumber", inputValue);
                          setErrorMessage({
                            ...errorMessage,
                            checkNumber: "",
                          });
                        } else {
                          // Display error message or handle invalid input
                          // For example:
                          setErrorMessage({
                            ...errorMessage,
                          });
                        }
                      }}
                      className={
                        errorMessage.checkNumber
                          ? styles.errorTextField
                          : styles.textField
                      }
                      placeholder="Enter Check Number"
                    />
                    {errorMessage.checkNumber ? ( 
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.checkNumber}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                {/* )} */}
                  <Grid xs={12} sm={3} item >
                    {CustomRequiredInputLabel("Reason for Refund", true)}
                    <CustomTextFeild
                    id="reasonForRefund"
                      fullWidth
                      required
                      value={formData.reasonforrefund}
                      onChange={(e) => {
                        handleFieldChange("reasonforrefund", e.target.value);
                        setErrorMessage({
                          ...errorMessage,
                          reasonforrefund: "",
                        });
                      }}
                      className={
                        errorMessage.reasonforrefund
                          ? styles.errorTextField
                          : styles.textField
                      }
                    />
                    {errorMessage.reasonforrefund ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.reasonforrefund}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>

                </Grid>
              </div>
            </Card>
          </div>
          <Box>
            <Grid xs={12} item>
              <div style={{ marginTop: "10px" }}>{handleButtons()}</div>
            </Grid>
          </Box>
        </form>
      </div>
    </>
  );
};

export default Refund;
